import { Link } from 'react-router-dom';
import { navItems, socialLinks } from '../constants';
import { LinkedInIcon } from './icons';
import EmailButton from './shared/EmailButton';

function Footer() {
  return (
    <footer className="pt-12 md:pt-16 pb-6 md:pb-8 px-6 md:px-12 border-t border-[#E5E5E5] bg-white">
      <div className="max-w-container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8">
          {/* Brand Section */}
          <div>
            <Link
              to="/"
              className="text-[#0D0D0D] font-playfair font-medium text-xl md:text-2xl hover:opacity-70 transition-opacity inline-block mb-4"
            >
              stephanie zhang
            </Link>
            <p className="text-sm text-[#666666] font-normal leading-relaxed">
              UI/UX Designer creating thoughtful digital experiences.
            </p>
          </div>

          {/* Navigation Section */}
          <div>
            <h3 className="text-base font-medium text-[#0D0D0D] mb-4">Navigation</h3>
            <ul className="space-y-2">
              {navItems.map((item) => (
                <li key={item.href}>
                  {item.isExternal ? (
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-[#666666] hover:text-[#0D0D0D] transition-colors"
                    >
                      {item.label}
                    </a>
                  ) : (
                    <Link
                      to={item.href}
                      className="text-sm text-[#666666] hover:text-[#0D0D0D] transition-colors"
                    >
                      {item.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Section */}
          <div>
            <h3 className="text-base font-medium text-[#0D0D0D] mb-4">Connect</h3>
            <div className="flex flex-col space-y-3">
              <EmailButton className="flex items-center gap-2 text-sm text-[#666666] hover:text-[#0D0D0D] transition-colors text-left">
                <span>Email</span>
              </EmailButton>
              <a
                href={socialLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-[#666666] hover:text-[#0D0D0D] transition-colors"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-[#E5E5E5] text-center">
          <p className="text-xs text-[#999999]">
            &copy; {new Date().getFullYear()} Stephanie Zhang. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

